export const isInBinance = () => {
  try {
    return (window as any)?.ethereum?.isBinance === true
  } catch (error) {
    return false
  }
}
